/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignEAFSGAreasToSubjectDTO
 */
export interface AssignEAFSGAreasToSubjectDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignEAFSGAreasToSubjectDTO
     */
    areaIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AssignEAFSGAreasToSubjectDTO
     */
    subjectId?: string;
}

export function AssignEAFSGAreasToSubjectDTOFromJSON(json: any): AssignEAFSGAreasToSubjectDTO {
    return AssignEAFSGAreasToSubjectDTOFromJSONTyped(json, false);
}

export function AssignEAFSGAreasToSubjectDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignEAFSGAreasToSubjectDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'areaIds': !exists(json, 'areaIds') ? undefined : json['areaIds'],
        'subjectId': !exists(json, 'subjectId') ? undefined : json['subjectId'],
    };
}

export function AssignEAFSGAreasToSubjectDTOToJSON(value?: AssignEAFSGAreasToSubjectDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'areaIds': value.areaIds,
        'subjectId': value.subjectId,
    };
}

